import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { BundleLineItemType } from '../__generated__/sharedTypes.js';

const upperFirst = (value)=>{
    return value[0].toUpperCase() + value.slice(1);
};
const mapToProductType = (lineItemRaw)=>{
    //TODO: Fix it properly with ticket
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(lineItemRaw.bundleLineItemsType){
        case BundleLineItemType.CONTACT_LENSES_BENELUX:
        case BundleLineItemType.CONTACT_LENSES_SUBSCRIPTION:
            return 'Contact-lenses';
        case BundleLineItemType.NON_PRESCRIPTION_BUNDLE:
        case BundleLineItemType.PRESCRIPTION_GLASSES:
            const mainLineItem = lineItemRaw.bundleLineItems.find((l)=>l.isMainBundleLineItem
            );
            const productType = mainLineItem === null || mainLineItem === void 0 ? void 0 : mainLineItem.legacyProduct.productType;
            if (!productType) {
                return null;
            }
            const capitalized = upperFirst(productType);
            if (!CommerceToolsApi.isProductTypeName(capitalized)) {
                return null;
            }
            return capitalized;
    }
    return null;
};
const getProductUrl = (formatProductUrl, lineItemRaw, slug, locale)=>{
    if (!slug) {
        return undefined;
    }
    if (lineItemRaw.__typename === 'LineItemBundle') {
        const productType = mapToProductType(lineItemRaw);
        if (!productType) {
            return undefined;
        }
        return formatProductUrl({
            productType,
            sku: lineItemRaw.sku,
            slug: {
                [locale]: slug
            }
        });
    }
    return formatProductUrl({
        productType: upperFirst(lineItemRaw.legacyProduct.productType),
        sku: lineItemRaw.sku,
        slug: {
            [locale]: slug
        }
    });
};

export { getProductUrl };
//# sourceMappingURL=get-line-item-product-url.js.map
